import { Form, Row, Col, Button } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { Request } from '@group-devs/yfp7-global-modules'

const request = new Request(process.env.apiDomain)

function emailNotification(props) {

    let contactAccount = props.contactAccount
    const [showUpdate, setShowUpdate] = useState(false);
    const [readOnly, setReadOnly] = useState(true);
    const [contactId, setContactId] = useState(null);
    const [data, setData] = useState({ 
        email_notif: null,
    })

    useEffect(() => {

        if(typeof contactAccount != 'undefined'){
            setData({ 
                email_notif: contactAccount ? contactAccount.contact.email : "",
            })
            
            if(contactAccount.contact.miscellaneous && contactAccount.contact.miscellaneous.data != null){
                let x = JSON.parse(contactAccount.contact.miscellaneous.data);
                x.map(function(item, i){
                    var d = JSON.parse(item);
                    if(typeof d.email_notif != "undefined"){
                        setData({ 
                            email_notif: d.email_notif,
                        })
                    }
                })
            }
            
            setContactId(contactAccount.contact_id)
        }
        
    }, [contactAccount]);

    const onClickEdit = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(false)
    }

    const onClickCancel = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(true)
    }

    function handleChange(evt)
    {
        const value = evt.target.value;
        setData({
          ...data,
          [evt.target.name]: value
        });
    }

    async function handleSave(e)
    {
        let notifData = {
            data: [JSON.stringify(data)]
        }
        
        let res = await request.contacts.updateMisc({...notifData, contact_id: contactId});
        console.log(res)
        if(res.err){
            console.log('error')
        }else{
            onClickCancel()
        }
    }
    return (
        <div className="emailNotification py-5 border-bottom">
            <Row>
                <Col xl={{span:10, offset:1}}>
                    <p><strong>Email Notifications</strong></p>
                    <p className="mb-4">We send all notifications and updates to your login <span className="text-success">email address</span> <br className="d-md-block d-none"/>
                        unless you specify another email address below.</p>
                    <Form>
                        <Form.Group as={Row} controlId="formPlaintextSend">
                            <Form.Label column md="3" className="text-md-right">Send Notifications</Form.Label>
                            <Col md="7">
                                <Form.Control type="email" className="rounded-0 mb-4" name="email_notif" onChange={handleChange} defaultValue={data.email_notif} readOnly={readOnly}/>
                                {!showUpdate && <Button onClick={onClickEdit} className="px-5 py-2 mb-2 btn btn-success rounded-pill"><strong>Edit</strong></Button>}
                                {showUpdate && 
                                    <>
                                        <Button className="px-5 py-2 mr-2 mb-2 btn btn-success rounded-pill" onClick={handleSave}><strong>Save</strong></Button> 
                                        <Button onClick={onClickCancel} className="px-5 py-2 mb-2 btn btn-secondary rounded-pill"><strong>Cancel</strong></Button> 
                                    </>
                                }                        
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default emailNotification
